import React, { useState, useEffect } from 'react'
import Loader from '../../../../presentationals/Loader/Loader.component';
import { SendAMUOTP, VerifyAMUOTP } from './ActionCreator';

export default function OTPPopup({ removeOTPPopup ,SearchData}) {
    const [loader, setLoader] = useState(false)
    const [timer, setTimer] = useState(30);
    const [otp, setOTP] = useState('')
    const [errorPopup, setErrorPopup] = useState(false)
    const [errorMessage, setError] = useState({})
const [popup,setPopup] =useState({
        show:false,
        severity:"",
        message:"",
    })
    
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [timer]);



    const handleOTP = (e) => {
        const inputValue = e.target.value;

        if (inputValue !== '') {
            e.target.classList.add('filled');
        } else {
            e.target.classList.remove('filled');
        }

        if (!/^\d?$/.test(inputValue)) {
            e.target.value = '';
            return;
        }

        const inputBox = e.target.id.charAt(6) * 1;
        const prev = 'digit-' + (inputBox - 1);
        const next = 'digit-' + (inputBox + 1);

        if (e.key === 'Backspace') {
            if (inputValue === '' && inputBox > 1) {
                e.preventDefault();
                document.getElementById(prev).focus();
            } else if (inputValue !== '') {
                e.target.value = '';
            } else if (inputBox > 1) {
                document.getElementById(prev).focus();
            }
        } else if (/^\d$/.test(inputValue) && inputBox < 5) {
            document.getElementById(next).focus();
        }

        handleOTPFunction()
    };

    const handlePaste = (e) => {
        const pastedData = e.clipboardData?.getData('text/plain') || e.target.value;
        const digits = pastedData.match(/\d/g);
        if (digits && digits.length === 4) {
            const inputBoxes = document.querySelectorAll('[id^=digit-]');
            inputBoxes.forEach((input, i) => {
                input.value = digits[i] || '';
                if (input.value !== '') {
                    input.classList.add('filled');
                } else {
                    input.classList.remove('filled');
                }
                if (i < inputBoxes.length - 1) {
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
        e.preventDefault();

        handleOTPFunction()
    };

    const handleOTPFunction = (e) => {
        let otp = "";
        let digit1 = document.getElementById('digit-1')?.value;
        let digit2 = document.getElementById('digit-2')?.value;
        let digit3 = document.getElementById('digit-3')?.value;
        let digit4 = document.getElementById('digit-4')?.value;
        let digit5 = document.getElementById('digit-5')?.value;

        if (!(digit1 && digit2 && digit3 && digit4 && digit5 )) {
        } else {
            otp = digit1 + digit2 + digit3 + digit4 + digit5 ;
            setOTP(otp)
        }
    }

    const VerifyOTP = (e) => {
     
        
        setLoader(true)
        VerifyAMUOTP(SearchData.mobileNumber,otp, (callback) => {
            setLoader(false)
            console.log(callback)
            // if (callback && callback?.status == 200 && callback?.data === 'success') {
            //     setPopupText({ text: '', heading: 'Phone Number Verified !', linkText: 'Proceed to Loan Form' })
            //     setShowSuccessPopup(true)
            // } else if (callback && callback.status == 200 && callback?.data === 'failure') {
            //     setErrorPopup(true)
            //     seterrorText('Please Enter Correct OTP')
            // } else {
            //     setErrorPopup(true)
            //     seterrorText('Please Try Again later!')

            // }
            // closeErrorPopup()
            if(callback){
                removeOTPPopup("crifReport")
            }else {
                }
        })
        setTimer(0)

    }

    const resendOTPHandler = (e) => {
        GetMobileOTPFunction('resendOTP')
    }



    const GetMobileOTPFunction = (type) => {
       
        if(type === "resendOTP"){
            setLoader(true)
            SendAMUOTP(SearchData.mobileNumber, (callback) => {
                setLoader(false)
                if(callback){
                    setPopup({show:true,severity:"success",message:"OTP Send Successfully"})
                }else{
                    setPopup({show:true,severity:"error",message:"Error: Please Try Again"})
                }
            })
        }
    }

    const closePopup = () => {
        removeOTPPopup("InputForm")
    }
    return (
        <>
            <div className='bg-grey' style={{ position: 'fixed', top: '0', bottom: '0', left: '0', right: '0', zIndex: '99', background: 'rgb(128 128 128 / 30%)' }}>
                <div class="modal d-block" tabindex="-1" style={{ top: '15%',display:'block' }}>
                    <div class="modal-dialog" style={{width:'40%'}}>
                        <div class="modal-content">

                            <div class="modal-body">
                                <div className="btns">
                                    <button style={{ background: 'red', color: '#fff', border: 'none', borderTopRightRadius: '6px', position: "absolute", top: '0', right: '0' }} onClick={() => closePopup()}><i class="fa fa-times" aria-hidden="true"></i></button>
                                </div>
                                {
                                    loader ?
                                        <Loader />
                                        : ''}
                                <div className="otpVerificationView">
                                    <div className="otpinputgrp">
                                        <input type="text" className="inputsOTP" id="digit-1" onInput={(e) => handleOTP(e)} onPaste={handlePaste} onKeyDown={(e) => handleOTP(e)} maxLength={1} inputMode="numeric" placeholder="0" />
                                        <input type="text" className="inputsOTP" id="digit-2" onInput={(e) => handleOTP(e)} onKeyDown={(e) => handleOTP(e)} maxLength={1} inputMode="numeric" placeholder="0" />
                                        <input type="text" className="inputsOTP" id="digit-3" onInput={(e) => handleOTP(e)} onKeyDown={(e) => handleOTP(e)} maxLength={1} inputMode="numeric" placeholder="0" />
                                        <input type="text" className="inputsOTP" id="digit-4" onInput={(e) => handleOTP(e)} onKeyDown={(e) => handleOTP(e)} maxLength={1} inputMode="numeric" placeholder="0" />
                                        <input type="text" className="inputsOTP" id="digit-5" onInput={(e) => handleOTP(e)} onKeyDown={(e) => handleOTP(e)} maxLength={1} inputMode="numeric" placeholder="0" /> 
                                    </div>
                                    <div className="someText">
                                        {errorMessage && errorMessage.field === 'otp' ? <p className="error-text">{errorMessage.msg}</p> : ""}
                                    </div>
                                    <div className="btns">
                                        <button className={`button1 ${otp?.length === 5 ? '' : 'disabled'} mb-4`} onClick={(e) => VerifyOTP(e)} disabled={otp?.length === 5 ? '' : 'disabled'}>
                                            Verify
                                        </button>
                                        <h5 className="resendTimer mb-3">{`Resend OTP in ${timer}s`}</h5>
                                        <button className={`resendbtn ${timer > 0 ? 'disabled' : ''}`} disabled={timer > 0 ? true : false} onClick={(e) => resendOTPHandler(e)}>Resend OTP</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
